import { render, staticRenderFns } from "./TheMessagesMenuList.vue?vue&type=template&id=3fc43e89&scoped=true"
import script from "./TheMessagesMenuList.vue?vue&type=script&lang=js"
export * from "./TheMessagesMenuList.vue?vue&type=script&lang=js"
import style0 from "./TheMessagesMenuList.vue?vue&type=style&index=0&id=3fc43e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc43e89",
  null
  
)

export default component.exports